// extracted by mini-css-extract-plugin
export default {"scrollSection":"DashboardPage_scrollSection__WvT-v"};